<template>
  <div class="container ta-left">
    <h1>Shimmer effects</h1>
    <h3>Shimmer</h3>
    <b-row class="mb-4">
      <b-col sm="12" class="code mb-2 mx-4">
        <p>import from '@/components/shimmers/shimmer'</p>
        <div class="mx-4">
          props: <br />
          <table class="table table-dark table-sm">
            <thead>
              <th>Name</th>
              <th>Type</th>
              <th>Default</th>
            </thead>
            <tr>
              <td>height</td>
              <td>string</td>
              <td>"1em"</td>
            </tr>
            <tr>
              <td>width</td>
              <td>string</td>
              <td>null</td>
            </tr>
            <tr>
              <td>maxWidth</td>
              <td>number</td>
              <td>100</td>
            </tr>
            <tr>
              <td>minWidth</td>
              <td>number</td>
              <td>80</td>
            </tr>
            <tr>
              <td>avatar</td>
              <td>boolean</td>
              <td>false</td>
            </tr>
            <tr>
              <td>rounded</td>
              <td>boolean</td>
              <td>false</td>
            </tr>
          </table>
        </div>
      </b-col>
      <b-col sm="4">
        <h5>**Default</h5>
        <shimmer class="mb-3" />
      </b-col>
      <b-col sm="4">
        <h5>**height="2em"</h5>
        <shimmer class="mb-3" height="2em" />
      </b-col>
      <b-col sm="4">
        <h5>**width="50%"</h5>
        <shimmer class="mb-3" width="50%" />
      </b-col>
      <b-col sm="4">
        <h5>**:avatar="true"</h5>
        <shimmer class="mb-3" :avatar="true" />
      </b-col>
      <b-col sm="4">
        <h5>**:rounded="true"</h5>
        <shimmer class="mb-3" :rounded="true" />
      </b-col>
      <b-col sm="4">
        <h5>**:pill="true"</h5>
        <shimmer class="mb-3" :pill="true" />
      </b-col>
    </b-row>
    <h3>Paragraphs</h3>
    <b-row class="mb-4">
      <b-col sm="12" class="code mb-2 mx-4">
        <p>import from '@/components/shimmers/paragraph'</p>
        <div class="mx-4">
          props: <br />
          <table class="table table-dark table-sm">
            <thead>
              <th>Name</th>
              <th>Type</th>
              <th>Default</th>
            </thead>
            <tr>
              <td>justified</td>
              <td>boolean</td>
              <td>false</td>
            </tr>
            <tr>
              <td>withTitle</td>
              <td>boolean</td>
              <td>false</td>
            </tr>
          </table>
        </div>
      </b-col>
      <b-col sm="4">
        <h5>**Default</h5>
        <paragraph-shimmer />
      </b-col>
      <b-col sm="4">
        <h5>**:justified="true"</h5>
        <paragraph-shimmer :justified="true" />
      </b-col>
      <b-col sm="4">
        <h5>**:withTitle="true"</h5>
        <paragraph-shimmer :withTitle="true" />
      </b-col>
    </b-row>
    <h3>Card shimmer</h3>
    <b-row>
      <b-col sm="12" class="code mb-2 mx-4">
        <p>import from '@components/shimmers/card'</p>
        <div class="mx-4">
          props: <br />
          <table class="table table-dark table-sm">
            <thead>
              <th>Name</th>
              <th>Type</th>
              <th>Default</th>
            </thead>
            <tr>
              <td>imageHead</td>
              <td>boolean</td>
              <td>true</td>
            </tr>
            <tr>
              <td>withTitle</td>
              <td>boolean</td>
              <td>true</td>
            </tr>
            <tr>
              <td>justified</td>
              <td>boolean</td>
              <td>false</td>
            </tr>
          </table>
        </div>
      </b-col>
      <b-col sm="4">
        <h5>**Default</h5>
        <card-shimmer class="mb-3"></card-shimmer>
      </b-col>
      <b-col sm="4">
        <h5>** :imageHead="false"</h5>
        <card-shimmer class="mb-3" :imageHead="false"></card-shimmer>
      </b-col>
      <b-col sm="4">
        <h5>** :withTitle="false"</h5>
        <card-shimmer class="mb-3" :withTitle="false"></card-shimmer>
      </b-col>
      <b-col sm="4">
        <h5>** :justified="true"</h5>
        <card-shimmer class="mb-3" :justified="true"></card-shimmer>
      </b-col>
    </b-row>

    <h3 class="mt-4">With Avatar <small>**customized</small></h3>
    <b-row class="mb-4">
      <b-col sm="4">
        <b-row>
          <b-col sm="2">
            <shimmer :avatar="true" height="50px"></shimmer>
          </b-col>
          <b-col sm="10">
            <shimmer width="60%" class="pt-2" height="30px"></shimmer>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <paragraph-shimmer />
          </b-col>
        </b-row>
      </b-col>
      <b-col> </b-col>
    </b-row>
  </div>
</template>
<script>
import cardShimmer from '@/components/shimmers/card'
import shimmer from '@/components/shimmers/shimmer'
import paragraphShimmer from '@/components/shimmers/paragraph'

export default {
  data() {
    return {
      loading: true
    }
  },
  components: {
    cardShimmer,
    shimmer,
    paragraphShimmer
  },
  mounted() {
    let t = this
    setTimeout(function() {
      t.loading = false
    }, 3000)
  }
}
</script>
<style lang="scss" scoped>
.code {
  background: #222 !important;
  color: #fff;
}
</style>
